export default function objectifyForm(form) {
  const formArray = form.serializeArray();
  const returnArray = {};
  for (let i = 0; i < formArray.length; i++) {
    returnArray[formArray[i]['name']] = encodeURIComponent(formArray[i]['value']);
  }
  return returnArray;
}
